
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-c-63-h-u-3-c-s-4-ue-dsi-0-p-qe-i-5-x-fl.json") })
        }
      }, "path---projects-c-63-h-u-3-c-s-4-ue-dsi-0-p-qe-i-5-x-fl");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---projects-c-63-h-u-3-c-s-4-ue-dsi-0-p-qe-i-5-x-fl!./.cache/json/projects-c-63-h-u-3-c-s-4-ue-dsi-0-p-qe-i-5-x-fl.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---projects-c-63-h-u-3-c-s-4-ue-dsi-0-p-qe-i-5-x-fl!./.cache/json/projects-c-63-h-u-3-c-s-4-ue-dsi-0-p-qe-i-5-x-fl.json
// module chunks = 15178676390636814000